export const historyReducerKey = 'historyReducerKey';
export const typeOfHistoryConfirmationDialog = 'typeOfHistoryConfirmationDialog';
export const typeOfHistorySaveDialog = 'typeOfHistorySaveDialog';
export const RECEIVED_RECENT_HISTORY = 'RECEIVED_RECENT_HISTORY';
export const RECEIVED_SAVED_HISTORY = 'RECEIVED_SAVED_HISTORY';
export const HANDLE_VIEW_SAVE_MODAL = 'HANDLE_VIEW_SAVE_MODAL';
export const HANDLE_NAME_CHANGE = 'HANDLE_NAME_CHANGE';
export const ON_SUBMIT_SAVE = 'ON_SUBMIT_SAVE';
export const ON_SUBMIT_COMPLETE = 'ON_SUBMIT_COMPLETE';
export const HANDLE_VIEW_DELETE_MODAL = 'HANDLE_VIEW_DELETE_MODAL';
export const ON_DELETE = 'ON_DELETE';
export const ON_DELETE_COMPLETE = 'ON_DELETE_COMPLETE';
export const ON_SAVE_UNLOAD = 'ON_SAVE_UNLOAD';
export const SearchTypes = {
  QUICK_SEARCH: 'quick',
  ADVANCED_SEARCH: 'advanced',
  SIMILARITY_SEARCH: 'similarity',
  DOCUMENT_SEARCH: 'document',
  SUBSTANCE_SEARCH: 'substance',
  TARGET_SEARCH: 'target',
  MARKUSH_SEARCH: 'markush',
  BATCH_SEARCH: 'batch',
  MANUALLY_FILTERED: 'manually',
  CROSS_LINKING: 'cross',
  MARKUSH_SUBSTANCES: 'relatedMarkush',
  MANUAL_SYNTHESIS: 'manualSynthesis',
  SUMMARY_REFERENCED_DOCUMENTS: 'summaryReferencedDocuments',
};
export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
